module.exports = __webpack_public_path__ + "img/twitter_logo.dc03ca45.png";